import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ICellRendererAngularComp } from "@bfx/ag-grid-angular";
import { FwdRollMutableRowModel } from "app/bfx-blotter-intervention/fwd-roll-pricing/models/FwdRollMutableRowModel";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: "fr-intent-renderer",
  template: `<span
      [ngStyle]="{ display: value != null && value.length > 0 ? '' : 'none' }"
      [ngClass]="{
        'fwd-roll-intent': true,
        'fwd-roll-intent-buy': isBuy,
        'fwd-roll-intent-sell': !isBuy,
      }"
    ></span
    ><span class="fwd-roll-intent"> {{ value }}</span>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FwdRollIntentRenderer implements ICellRendererAngularComp {
  public isBuy: boolean;
  public value: string;
  private previous: { isBuy: boolean; value: string };

  constructor(public cd: ChangeDetectorRef) {
    this.previous = { isBuy: this.isBuy, value: this.value };
  }

  // called on init
  agInit(params: ICellRendererParams): void {
    this.doVal(params);
  }

  doVal(params: ICellRendererParams): boolean {
    this.previous.value = this.value;
    this.previous.isBuy = this.isBuy;

    this.isBuy = (params.data as FwdRollMutableRowModel).intent == CubiqTS.OrderIntent.BUY;
    this.value = params.value;

    if (this.value !== this.previous.value) {
      params.eGridCell.title = params.value;
      return true;
    }
    return this.isBuy !== this.previous.isBuy || this.value !== this.previous.value;
  }

  // called when the cell is refreshed
  refresh(params: ICellRendererParams): boolean {
    if (this.doVal(params)) {
      this.cd.markForCheck();
    }

    return true;
  }
}
